var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.714 13.0006H2.42829V1.8577C2.42829 1.77913 2.36401 1.71484 2.28544 1.71484H1.28544C1.20686 1.71484 1.14258 1.77913 1.14258 1.8577V14.1434C1.14258 14.222 1.20686 14.2863 1.28544 14.2863H14.714C14.7926 14.2863 14.8569 14.222 14.8569 14.1434V13.1434C14.8569 13.0648 14.7926 13.0006 14.714 13.0006ZM4.31758 10.2452C4.37294 10.3006 4.46222 10.3006 4.51936 10.2452L6.98901 7.78806L9.26758 10.0809C9.32294 10.1363 9.41401 10.1363 9.46937 10.0809L14.3872 5.16484C14.4426 5.10949 14.4426 5.01842 14.3872 4.96306L13.6801 4.25592C13.6532 4.22933 13.617 4.21442 13.5792 4.21442C13.5414 4.21442 13.5051 4.22933 13.4783 4.25592L9.37115 8.36127L7.09615 6.07199C7.0693 6.0454 7.03304 6.03049 6.99526 6.03049C6.95747 6.03049 6.92122 6.0454 6.89437 6.07199L3.61222 9.33449C3.58564 9.36134 3.57072 9.39759 3.57072 9.43538C3.57072 9.47316 3.58564 9.50942 3.61222 9.53627L4.31758 10.2452Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAnalysis);
export default __webpack_public_path__ + "static/media/sidebar-analysis.27af63f70e1f5e8a903a53be3af6c469.svg";
export { ForwardRef as ReactComponent };